<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="white"
    :transparent="true"
  >
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
      <div class="navbar-toggle d-inline" :class="{ toggled: $sidebar.showSidebar }">
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <router-link :to="{name:'manager.dashboard'}" class="navbar-brand">
        {{ companyName }}
      </router-link>
    </div>

    <ul class="navbar-nav mr-auto d-flex align-items-center">
      <li class="nav-item" v-if="refresh" style="list-style: none; padding-left: 10px;">
        <div class="alert alert-primary alert-version mb-0">
          <div class="mt-1">
            Nova versão disponível, clique
            <span class="badge badge-black cursor-pointer" @click="updatePage">{{ $t('placeholders.here') }}</span>
            para atualizar
          </div>
        </div>
      </li>
    </ul>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <div class="form-inline">
        <li class="nav-item d-flex align-items-center" style="width: 340px;">
          <base-input
            :placeholder="$t('modals.search_invoice_modal.placeholder')"
            v-model="nfNumber"
            @keyup.enter.native="searchNf"
            style="flex-grow: 1;"
            :disableSuccessState="true"
          />
          <base-button
            icon
            @click="searchNf"
            type="primary"
            style="margin-left: 8px;"
          >
            <i class="tim-icons icon-zoom-split"></i>
          </base-button>
        </li>
      </div>

      <div class="form-inline">
        <div class="togglebutton switch-change-color mt-4">
          <base-switch v-model="darkModeSw" @input="toggleMode">
            <i class="material-icons icon-for-switch" slot="on">nights_stay</i>
            <i class="material-icons text-white icon-for-switch" slot="off">wb_sunny</i>
          </base-switch>
        </div>

        <system-notification-button ref="system_notification_button" />
      </div>

      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template slot="title">
          <div class="row">
            <div class="col">
              <div :class="imageSrc== '/img/placeholder.jpg'? 'photo mt-2':'photo-square'"><img :src="imageSrc"/></div>
            </div>
            <span class="mt-3 material-icons">arrow_drop_down</span>
          </div>
          <p class="d-lg-none">{{$t('pages.layout.logout') }}</p>
        </template>
        <li class="nav-link">
          <router-link :to="{name:'home.profile'}" class="nav-item dropdown-item">{{ $t('pages.layout.profile') }}</router-link>
        </li>
        <!-- TEMPORÁRIO, PARA TESTAR FUNCIONALIDADE DE IDIOMA -->
        <li class="nav-link">
          <a v-if="$i18n.locale == 'en'" class="nav-item dropdown-item" @click="changeLanguage('pt')">
            <img src="https://img.icons8.com/officexs/16/000000/brazil.png"/> PT-BR
          </a>
        </li>
        <li class="nav-link">
          <a v-if="$i18n.locale == 'pt'" class="nav-item dropdown-item" @click="changeLanguage('en')">
            <img src="https://img.icons8.com/officexs/16/000000/usa.png"/> EN-US
            </a>
        </li>
        <!-- ----------------------------------------------- -->
        <li class="nav-link">
          <router-link :to="{name:'home.menu'}" class="nav-item dropdown-item">{{ $t('pages.layout.home') }}</router-link>
        </li>
        <li class="nav-link">
          <a class="nav-item dropdown-item" @click="logoutSystem">{{ $t('pages.layout.logout') }}</a>
        </li>
      </base-dropdown>
    </ul>

    <search-nf-modal ref="search_nf_modal" @close="clearNfNumber"/>
  </base-nav>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions';
  import { BaseNav, Modal } from '@/resources/components';
  import SidebarToggleButton from '@/resources/layouts/SidebarToggleButton';
  import {mapActions, mapGetters} from "vuex";
  import BaseSwitch from "@/resources/components/BaseSwitch";
  import * as Cookies from "js-cookie";
  import lang from 'element-ui/lib/locale/lang/pt-br';
  import lang_en from 'element-ui/lib/locale/lang/en';
  import locale from 'element-ui/lib/locale';
  import SystemNotificationButton from '@/resources/components/Notification/SystemNotificationButton';
  import SearchNfModal from "@/resources/components/Modal/SearchNfModal";


  export default {
    components: {
      SidebarToggleButton,
      CollapseTransition,
      BaseNav,
      Modal,
      BaseSwitch,
      SystemNotificationButton,
      SearchNfModal,
    },
    props: {
      refresh: {
        default: false
      }
    },
    created() {
      let docClasses = document.body.classList;
      if (this.darkMode == 'true') {
        docClasses.remove('white-content');
      } else {
        docClasses.add('white-content');
      }
      this.darkModeSw = this.darkMode=='true';
      this.companyName = this.token.user.company.fantasy_name
    },
    computed: {
      ...mapGetters({
        darkMode: "getColor"
      }),
      token() {
        return Cookies.getJSON("token");
      },
      routeName() {
        const { name } = this.$route;
        return this.$t('pages.shipper.title.'+name);
      },
      isRTL() {
        return this.$rtl.isRTL;
      },
      imageSrc(){
        if(this.token.user.company.avatar_path){

          return this.base+'/'+this.token.user.company.avatar_path;
        }else{
          return "/img/placeholder.jpg"
        }
      }
    },
    data() {
      return {
        companyName: '',
        darkModeSw: this.darkMode,
        activeNotifications: false,
        showMenu: false,
        searchModalVisible: false,
        searchQuery: '',
        base: document.location.protocol + "//" + process.env.VUE_APP_API_HOST,
        locale,
        lang,
        lang_en,
        nfNumber: null,
      };
    },
    methods: {
      ...mapActions(["logout","setColorCookie"]),
      toggleMode(type) {
        this.setColorCookie(type);
        let docClasses = document.body.classList;
        if (type) {
          docClasses.remove('white-content');
        } else {
          docClasses.add('white-content');
        }
        this.darkModeSw =type;
      },
      async logoutSystem() {
        this.$refs.system_notification_button.disconnect();
        await this.logout();
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      updatePage(){
        this.$emit('update-page')
      },
      changeLanguage(lang){
        this.$i18n.locale = lang
        this.locale.use(lang == 'en' ? this.lang_en : this.lang)
        this.$emit('language')
      },
      searchNf() {
        if (this.nfNumber && this.nfNumber.trim() !== '') {
          this.$refs.search_nf_modal.show(this.nfNumber);
        }
      },
      clearNfNumber() {
        this.$set(this, 'nfNumber', null);
      }
    }
  };
</script>
<style scoped>
  .top-navbar {
    top: 0px;
  }
  .icon-for-switch{
    line-height: inherit;
  }
</style>
